import * as actionTypes from './actionsTypes';

export function getReplayList(params) {
	return {
		type: actionTypes.EVAC_REPLAY_LIST_GET,
		payload: {
			params,
		},
	};
}

export function getReplayData(params) {
	return {
		type: actionTypes.EVAC_REPLAY_DATA_GET,
		payload: {
			params,
		},
	};
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/actions/evacReplay.js